export default __webpack_public_path__ + "static/media/autopflege.fe12938d.svg";